import {TipoMeteorologia} from "./enums";
import {Entidade} from "./Entidade";
import {Entity, JoinColumn, PrimaryGeneratedColumn} from "typeorm/browser";
import {Column, ManyToOne} from "typeorm";
import {Especime} from "./Especime";
import {Projeto} from "./Projeto";

@Entity("meteorologiaespecime")
export class MeteorologiaEspecime   extends Entidade{
  @Column()//"date")
  dataHora?: string
  @Column()
  tipo?: TipoMeteorologia
  @Column()
  valor?: number
  @ManyToOne(() => Especime, (especime) => especime.meteorologias)
  @JoinColumn({name: "especime_id"})
  especime?: Especime

  get valorCompleto(): string {
    return this.valor + " (" + this.tipo + ")"
  }
}

